import React, { FC } from 'react';
import {useStoreon} from 'storeon/react';
import { State } from '@/interfaces';
import Modal403 from '../components/Modal403';
import {TYPE_USER} from '../const';

const CheckViewer: FC<React.ReactNode> = ({ children}) => {
    const {currentUser} = useStoreon<State>('currentUser')
    return (
        <>
            {currentUser.status && currentUser.user_status === TYPE_USER.VIEWER  ?
             <Modal403/> :
             <>
                 {children}
             </>
            }
        </>
    )
}

export default CheckViewer;